import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './FruitGiveaway.css';

const FRUIT_IMAGE = '/images/giveaway/giveaway.png'; 
const API_URL = 'https://giveawaybackend-8gpt.onrender.com/usernames';

function getPHNextWeekCountdown() {
  // Get current time in UTC+8 (Philippines)
  const now = new Date();
  const utc8 = new Date(now.getTime() + (8 - now.getTimezoneOffset() / 60) * 60 * 60 * 1000);

  // Find next Monday 00:00:00 UTC+8
  const day = utc8.getUTCDay(); // 0=Sunday, 1=Monday, ..., 6=Saturday
  const daysUntilNextMonday = (8 - day) % 7 || 7;
  const nextMonday = new Date(utc8);
  nextMonday.setUTCDate(utc8.getUTCDate() + daysUntilNextMonday);
  nextMonday.setUTCHours(0, 0, 0, 0);

  // Calculate remaining time in ms
  const diff = nextMonday - utc8;
  const seconds = Math.floor((diff / 1000) % 60);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  return { days, hours, minutes, seconds };
}

export default function FruitGiveaway() {
  const [username, setUsername] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [usernames, setUsernames] = useState([]);
  const [timer, setTimer] = useState(getPHNextWeekCountdown());

  // Fetch usernames from backend
  useEffect(() => {
    fetch(API_URL)
      .then(res => res.json())
      .then(data => setUsernames(data.map(u => u.name)));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(getPHNextWeekCountdown());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    if (username.trim()) {
      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: username.trim() }),
      })
        .then(res => res.json())
        .then(() => {
          setSubmitted(true);
          setUsername('');
          // Fetch the latest usernames from the backend
          fetch(API_URL)
            .then(res => res.json())
            .then(data => setUsernames(data.map(u => u.name)));
          setTimeout(() => setSubmitted(false), 2000);
        });
    }
  };

    return (
    <div className="giveaway-container">
      <Helmet>
        <title>Roblox Fruit Giveaway | Nectar Thorn | HydroPlayz</title>
        <meta
          name="description"
          content="Join the weekly Roblox Fruit Giveaway by HydroPlayz! Win a rare Nectar Thorn fruit (value: 4,353,803,433,731). Follow, subscribe, and enter your Roblox username to participate."
        />
        <meta
          name="keywords"
          content="Roblox, Fruit Giveaway, Nectar Thorn, HydroPlayz, Roblox giveaway, Roblox fruit, Roblox contest, Roblox event, Roblox free, Roblox rare fruit"
        />
        <meta property="og:title" content="Roblox Fruit Giveaway | Nectar Thorn | HydroPlayz" />
        <meta property="og:description" content="Join the weekly Roblox Fruit Giveaway by HydroPlayz! Win a rare Nectar Thorn fruit. Follow, subscribe, and enter your Roblox username to participate." />
        <meta property="og:image" content={FRUIT_IMAGE} />
        <meta property="og:type" content="website" />
      </Helmet>
                <div className="giveaway-timer">
  <b>Time left until next giveaway reset (PH Time):</b><br />
  {timer.days}d {timer.hours}h {timer.minutes}m {timer.seconds}s
</div>
      <h2>Fruit Giveaway!</h2>
      <div className="giveaway-fruit-section">
        <img src={FRUIT_IMAGE} alt="Nectar Thorn" className="giveaway-fruit-img" />
        <div className="giveaway-fruit-info">
          <h3>Nectar Thorn</h3>
          <p>
            Roblox Username: <span className="roblox-username">@xxXxxHydroPlayzxxXxx</span>
          </p>
          <p className="giveaway-fruit-value">
            Value: <b>4,353,803,433,731</b>
          </p>
        </div>
      </div>
      <div className="giveaway-socials">
        <a
          href="https://www.youtube.com/@HydroPlayz-r2g"
          className="giveaway-social-btn youtube"
          target="_blank"
          rel="noopener noreferrer"
        >
          Subscribe YouTube
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=100064169436154"
          className="giveaway-social-btn facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          Like Facebook
        </a>
        <a
          href="https://www.tiktok.com/@hydroplayz3"
          className="giveaway-social-btn tiktok"
          target="_blank"
          rel="noopener noreferrer"
        >
          Follow TikTok
        </a>
      </div>
      <div className="giveaway-main-flex">
        <div className="giveaway-form-section">
          <form className="giveaway-form" onSubmit={handleSubmit}>
            <label>
              Enter your Roblox username to join:
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Your Roblox username"
                required
              />
            </label>
            <button type="submit">Join Giveaway</button>
          </form>
          {submitted && (
            <div className="giveaway-success">
              Thank you! You have joined the giveaway.
            </div>
          )}
          <div className="giveaway-note">
            <b>To join:</b> Follow/Subscribe on all platforms and enter your Roblox username above!
          </div>
          <div className="giveaway-weekly">
            <em>Note: The giveaway fruit changes every week!</em>
          </div>
        </div>
        <div className="giveaway-usernames-box">
          <div className="giveaway-usernames-title">Recent Entries</div>
          <div className="giveaway-usernames-list">
            {usernames.length === 0 ? (
              <div className="giveaway-usernames-empty">No entries yet.</div>
            ) : (
              usernames.map((name, idx) => (
                <div key={idx} className="giveaway-username-item">
                  {name}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}